interface ConversationStatisticResponse {
  currentTotals: TotalStats;
  comparedTotals: TotalStats;
  growth: GrowthStats;
  graphStats: HourlyStats[];
}

interface UserStatisticResponse {
  totalLogins: number;
  loginPercentageChange: number;
  totalConversations: number;
  conversationPercentageChange: number;
  totalMessages: number;
  messagePercentageChange: number;
  graphStats: UserGraphStat[];
}

type MostUsedDocumentsResponse = MostUsedDocument[];

interface MostUsedDocument {
  documentId: string;
  documentTitle: string;
  documentType: string;
  documentSource: string;
  usageCount: number;
  workspaceId?: string;
}

interface MostUsedDocumentsRequest {
  totalCount: number;
  sortDirection: MostUsedDocumentsSortDirection;
  type: DocumentSourceTypes;
}

enum MostUsedDocumentsSortDirection {
  MostUsed = "MostUsed",
  LeastUsed = "LeastUsed",
}

enum DocumentSourceTypes {
  Workspace = "Workspace",
  Law = "Law",
}

interface UserGraphStat {
  userName: string;
  loginCount: number;
  conversationCount: number;
  messageCount: number;
}

interface TotalStats {
  totalConversations: number;
  totalWordConversations: number;
  totalMessages: number;
  totalWordMessages: number;
  wordConversationPercentage: number;
  wordMessagePercentage: number;
  ratingPercentage: number;
  averageRating: number;
}

interface HourlyStats {
  hour: string; // DateTimeOffset as ISO string
  nonWordConversationCount?: number;
  wordConversationCount?: number;
  nonWordMessageCount: number;
  wordMessageCount?: number;
}

interface GrowthStats {
  conversationGrowth: number;
  wordConversationGrowth: number;
  messageGrowth: number;
  wordMessageGrowth: number;
  ratingGrowth: number;
}

interface ConversationStatisticRequest {
  startDate: string;
  endDate: string;
  comparedStartDate: string;
  comparedEndDate: string;
}

export type {
  ConversationStatisticResponse,
  UserStatisticResponse,
  TotalStats,
  HourlyStats,
  GrowthStats,
  ConversationStatisticRequest,
  MostUsedDocumentsRequest,
  MostUsedDocumentsResponse,
  MostUsedDocument,
};

export { MostUsedDocumentsSortDirection, DocumentSourceTypes };
